interface NamedOption {
  Name: string;
  ParentId?: number | null;
}

export const sortAndDeduplicateByName = <T extends NamedOption>(
  options: T[],
): T[] => {
  const uniqueByNameAndParent = new Map<string, T>();

  options.forEach((option) => {
    const normalizedName = option.Name.trim().toLocaleLowerCase();
    const normalizedParentId =
      option.ParentId == null ? 'root' : String(option.ParentId);
    const dedupeKey = `${normalizedParentId}:${normalizedName}`;

    if (!uniqueByNameAndParent.has(dedupeKey)) {
      uniqueByNameAndParent.set(dedupeKey, option);
    }
  });

  return Array.from(uniqueByNameAndParent.values()).sort((a, b) =>
    a.Name.localeCompare(b.Name, undefined, { sensitivity: 'base' }),
  );
};
